import { Card, Text } from '@hh.ru/magritte-ui';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import translation from 'src/components/translation';

const TrlKeys = {
    title: 'employer.vacancyResponses.responseComplaint',
};

interface ComplaintProps {
    onClick: () => void;
}

const Complaint: TranslatedComponent<ComplaintProps> = ({ trls, onClick }) => {
    return (
        <Card
            onClick={onClick}
            borderRadius={16}
            padding={12}
            paddingLeft={16}
            hoverStyle="secondary"
            stretched
            data-qa="resume-complaint-button"
        >
            <Text style="primary" typography="label-2-regular">
                {trls[TrlKeys.title]}
            </Text>
        </Card>
    );
};

export default translation(Complaint);
